"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _createSvgIcon = _interopRequireDefault(require("../utils/createSvgIcon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = exports["default"] = (0, _createSvgIcon["default"])( /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("title", null, "Trace Icons_1-3"), /*#__PURE__*/_react["default"].createElement("g", {
  id: "Artboard-32"
}), /*#__PURE__*/_react["default"].createElement("polygon", {
  points: "16.65 9.84 15.35 9.84 15.35 15.35 9.84 15.35 9.84 16.65 15.35 16.65 15.35 22.16 16.65 22.16 16.65 16.65 22.16 16.65 22.16 15.35 16.65 15.35 16.65 9.84"
}), /*#__PURE__*/_react["default"].createElement("path", {
  d: "M23.14,3.64H8.86L1.72,16,8.86,28.36H23.14L30.28,16Zm-.75,23.42H9.61L3.23,16,9.61,4.94H22.39L28.78,16Z"
})));
module.exports = exports.default;